import React from 'react';
import Button from 'react-bootstrap/Button';

class Back extends React.Component {
  render(){
    return(
      <Button
        size="lg"
        id="see-all-button"
        style={{background: "transparent", border: "none", padding: "0px"}}
        onClick={()=>this.props.allMemes()}>
        &#8592; Back to the Posse
      </Button>
    )
  }
}

export default Back;